// import Swiper from "swiper";
import utils from "./utils";
export default function () {

 var hero = new Swiper(".swiper-container-hero", {
	slidesPerView: "auto",
	spaceBetween: 30,
	autoHeight: true,
	loop: true,
	navigation: {
	  nextEl: ".swiper-button-next-hero",
	  prevEl: ".swiper-button-prev-hero",
	},
	pagination: {
		el: ".swiper-pagination-hero",
		clickable: true,
	  },
  });

  var about = new Swiper(".swiper-container-about", {
	slidesPerView: "auto",
	spaceBetween: 30,
	loop: true,
	pagination: {
	  el: ".swiper-pagination-about",
	  clickable: true,
	},
	navigation: {
	  nextEl: ".swiper-button-next-about",
	  prevEl: ".swiper-button-prev-about",
	},
  });

  var team = new Swiper(".swiper-container-team", {
    slidesPerView: "auto",
    spaceBetween: 30,
	loop: true,
    pagination: {
      el: ".swiper-pagination-team",
      clickable: true,
    },
  });

  var icons = new Swiper(".swiper-container-icon", {
    slidesPerView: "auto",
	loop: true,
	spaceBetween: 30,
    pagination: {
      el: ".swiper-pagination-icon",
      clickable: true,
    },
  });
  

  var gallery = new Swiper(".swiper-container-gallery", {
	slidesPerView: "auto",
	spaceBetween: 30,
	loop: true,
	pagination: {
	  el: ".swiper-pagination-gallery",
	  clickable: true,
	},
	navigation: {
	  nextEl: ".swiper-button-next-gallery",
	  prevEl: ".swiper-button-prev-gallery",
	},
  });

  if (utils.isMobile()) {
    var stepIcons = new Swiper(".swiper-container-step-icons", {
      slidesPerView: "1",
	  spaceBetween: 0,
	  loop: true,
      pagination: {
        el: ".swiper-pagination-step-icons",
        clickable: true,
	  },
	  navigation: {
		nextEl: ".swiper-button-next-step-icons",
		prevEl: ".swiper-button-prev-step-icons",
	  },
    });
  }
}
